var _path, _path2, _path3, _path4, _path5, _path6, _g, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFis(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2",
    "data-name": "Group 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 69.427,
    height: 29,
    viewBox: "0 0 69.427 29",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M131.1,188.96a1.534,1.534,0,0,0-1.533-1.535H111.855a5.719,5.719,0,1,0,0,11.434h14.222a2.653,2.653,0,0,1,0,5.3H108.372a1.533,1.533,0,1,0,0,3.066h17.705a5.717,5.717,0,1,0,0-11.431H111.855a2.652,2.652,0,0,1,0-5.3h17.707a1.534,1.534,0,0,0,1.533-1.535",
    transform: "translate(-62.505 -178.363)",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M94.875,176.325a2.231,2.231,0,1,0-2.231,2.231,2.231,2.231,0,0,0,2.231-2.231",
    transform: "translate(-57.513 -174.094)",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M84.415,176.325a2.231,2.231,0,1,0-2.231,2.231,2.231,2.231,0,0,0,2.231-2.231",
    transform: "translate(-54.163 -174.094)",
    fill: "#fff",
    opacity: 0.8
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M73.953,176.325a2.231,2.231,0,1,0-2.23,2.231,2.231,2.231,0,0,0,2.23-2.231",
    transform: "translate(-50.813 -174.094)",
    fill: "#fff",
    opacity: 0.6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M63.493,176.325a2.231,2.231,0,1,0-2.23,2.231,2.23,2.23,0,0,0,2.23-2.231",
    transform: "translate(-47.463 -174.094)",
    fill: "#fff",
    opacity: 0.4
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M53.033,176.325a2.231,2.231,0,1,0-2.23,2.231,2.23,2.23,0,0,0,2.23-2.231",
    transform: "translate(-44.113 -174.094)",
    fill: "#fff",
    opacity: 0.2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0 9.063)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M67.245,187.427c-.048,0-.094.009-.139.014v-.014H52.047c-5.982,0-10.035,3.916-10.035,9.9v8.366a1.672,1.672,0,1,0,3.344,0v-8.366c0-4.147,2.509-6.831,6.691-6.831H67.106v-.014c.046,0,.092.014.139.014a1.533,1.533,0,1,0,0-3.067",
    transform: "translate(-42.012 -187.427)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M49.394,201.266a1.534,1.534,0,0,0,1.534,1.535H66.263a1.534,1.534,0,0,0,0-3.068H50.928a1.534,1.534,0,0,0-1.534,1.534",
    transform: "translate(-44.376 -191.368)",
    fill: "#fff"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M91.233,188.9v16.729a1.674,1.674,0,1,0,3.347,0V188.9a1.674,1.674,0,0,0-3.347,0",
    transform: "translate(-57.775 -178.299)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFis);
export default __webpack_public_path__ + "static/media/fis.78ba07d93083a69b195c8c0d00591e62.svg";
export { ForwardRef as ReactComponent };